import {css} from "@panda/css";

import {SemanticSearchLoginForm} from "../../../auth/components/auth_card/SemanticSearchLoginForm";
import {UserSource} from "../../../tracking/tracking_utils/user_source";
import {useSemanticSearchPostAuthNavigation} from "../../hooks/use_semantic_search_post_auth_navigation";

export const SemanticSearchAuthLoginForm = () => {
    const {completeAuthFlow} = useSemanticSearchPostAuthNavigation();

    const handleAuthSuccess = () => {
        void completeAuthFlow();
    };

    return (
        <div className={container}>
            <SemanticSearchLoginForm userSource={UserSource.REGISTRATION} socialAuthSuccess={handleAuthSuccess} emailAuthSuccess={handleAuthSuccess} />
        </div>
    );
};

const container = css({
    display: "flex",
    flexDirection: "column",
    gap: 1.5
});
import {css} from "@panda/css";

import {SemanticSearchLoginForm} from "../../../auth/components/auth_card/SemanticSearchLoginForm";
import {UserSource} from "../../../tracking/tracking_utils/user_source";
import {useSemanticSearchPostAuthNavigation} from "../../hooks/use_semantic_search_post_auth_navigation";

export const SemanticSearchAuthLoginForm = () => {
    const {completeAuthFlow} = useSemanticSearchPostAuthNavigation();

    const handleAuthSuccess = () => {
        void completeAuthFlow();
    };

    return (
        <div className={container}>
            <SemanticSearchLoginForm userSource={UserSource.REGISTRATION} socialAuthSuccess={handleAuthSuccess} emailAuthSuccess={handleAuthSuccess} />
        </div>
    );
};

const container = css({
    display: "flex",
    flexDirection: "column",
    gap: 1.5
});
